// export const BASE_URL_V3 = "https://myparking.opentech4u.co.in/v3/api";
// export const BASE_URL = "https://admincecwb.opentech4u.co.in";
export const BASE_URL = "https://webapi.benfed.in";
export const BASE_BENFED_URL = "https://benfed.in/benfed_godown/index.php/api";
// export const BASE_URL_V3 = "http://192.168.1.252:3001/v3/api";

// export const DOMAIN_NAME = "http://localhost:3001/"; // Local

// export const DOMAIN_NAME = "https://demo.benfed.in/"; // Production

export const DOMAIN_NAME = "https://benfed.org/"; // Production


